import {connect} from 'react-redux';
import {scrollRoot} from 'reducers/ui/uiActions';
import Form from './Form';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    onScrollToTopGlobal: scrollRoot,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(Form);



// WEBPACK FOOTER //
// ./src/components/controls/form/FormContainer.js